import { Box, Container, Typography } from '@mui/material';
import { OrganizationManagement } from 'components/templates/OrganizationMangement';
import React from 'react';

export const Organizations = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'left' }}>
          Organizations
        </Typography>
      </Box>
      <OrganizationManagement />
    </Container>
  );
};
